module.exports = __webpack_public_path__ + "static/media/wedding.31e65e41.ics";